/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx';
import { useState } from 'react';
import { KTIcon } from '../../../../helpers';
import { CreateAppModal, Dropdown1 } from '../../../../partials';
import { useLayout } from '../../../core';
import { useNavigate } from 'react-router-dom';

interface ToolbarDailyMonitoringProps {
  claimType: string;
  onModalClose: () => void;
}

const ToolbarDailyMonitoring: React.FC<ToolbarDailyMonitoringProps> = ({ claimType, onModalClose }) => {
  const { config } = useLayout();
  const navigate = useNavigate();
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false);
  const [isHovering, setIsHovering] = useState<boolean>(false);
  const daterangepickerButtonClass = config.app?.toolbar?.fixed?.desktop
    ? 'btn-light'
    : 'bg-body btn-color-gray-700 btn-active-color-primary';

  const handleDaftarClick = () => {
      setShowCreateAppModal(true); 
  };

  return (
    <div 
      className='d-flex align-items-center gap-2 gap-lg-3'
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {isHovering && (
        <>
          {config.app?.toolbar?.primaryButton && (
            <a
              href='#'
              onClick={handleDaftarClick}
              className='btn btn-sm fw-bold btn-primary'
            >
            +
            </a>
          )}
        </>
      )}
      <CreateAppModal 
        show={showCreateAppModal} 
        handleClose={() => {
          setShowCreateAppModal(false);
          onModalClose();
        }}  
      />
    </div>
  );
};

export { ToolbarDailyMonitoring };
